<template>
  <div class="preloader">
    <div class="preloader_overlay">
      <div class="preloader_content">
        <div class="preloader_circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "step_preloader",
    methods: {
      preloaderClose(){
        this.$el.style.display = 'none';
      },
      preloaderOpen(){
        this.$el.style.display = 'flex';
      }
    }
  }
</script>

